import { render, staticRenderFns } from "./ResetPassProvider.vue?vue&type=template&id=2d225547&scoped=true"
import script from "./ResetPassProvider.vue?vue&type=script&lang=js"
export * from "./ResetPassProvider.vue?vue&type=script&lang=js"
import style0 from "./ResetPassProvider.vue?vue&type=style&index=0&id=2d225547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d225547",
  null
  
)

export default component.exports